import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const EditButton = ({ onClick, disabled }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main primary-button'} onClick={onClick} disabled={disabled}>
            {t('common:buttons.edit')}
        </button>
    );
};
